import { useState } from 'react'

import './_AgeVerificationModal.scss'

interface AgeVerificationModalProps {
    onClose: () => void
    onConfirm: () => void
}

const AgeVerificationModal = ({
    onClose,
    onConfirm
}: AgeVerificationModalProps) => {
    const [isClosing, setIsClosing] = useState(false)

    const closeWithAnimation = () => {
        setIsClosing(true)

        window.setTimeout(() => {
            onClose()
        }, 150)
    }

    const confirmWithAnimation = () => {
        setIsClosing(true)

        window.setTimeout(() => {
            onConfirm()
        }, 150)
    }

    return (
        <div
            className={`age-verification-overlay ${
                isClosing ? 'age-verification-overlay--closing' : ''
            }`}
        >
            <div className='age-verification-modal'>
                <button
                    type='button'
                    className='age-verification-modal__close'
                    onClick={closeWithAnimation}
                >
                    ×
                </button>

                <div className='age-verification-modal__logo'>
                    <svg
                        width='36'
                        height='42'
                        viewBox='0 0 36 42'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'
                    >
                        <path
                            d='M0 13.8486H13.9925C21.7204 13.8486 27.9851 20.1133 27.9851 27.8412C27.9851 35.569 21.7204 41.8337 13.9925 41.8337C6.26467 41.8337 0 35.569 0 27.8412V13.8486Z'
                            fill='#4964DE'
                        />
                        <path
                            opacity='0.6'
                            d='M35.292 28.1523L21.2995 28.1523C13.5716 28.1523 7.30692 21.8877 7.30692 14.1598C7.30692 6.43194 13.5716 0.167273 21.2995 0.167273C29.0273 0.167274 35.292 6.43195 35.292 14.1598L35.292 28.1523Z'
                            fill='#0FECD9'
                        />
                    </svg>
                </div>

                <h2 className='age-verification-modal__title'>
                    Age Verification
                </h2>

                <div className='age-verification-modal__divider'>
                    <span>Adults only</span>
                </div>

                <p className='age-verification-modal__text'>
                    You must be at least 18 years old, or the age of majority in
                    your jurisdiction, to access AllFans.
                </p>

                <p className='age-verification-modal__subtext'>
                    By continuing, you confirm that you meet this requirement.
                </p>

                <button
                    type='button'
                    className='age-verification-modal__confirm'
                    onClick={confirmWithAnimation}
                >
                    I am 18 or older
                </button>

                <button
                    type='button'
                    className='age-verification-modal__exit'
                    onClick={() => {
                        window.location.replace('https://www.google.com')
                    }}
                >
                    Exit
                </button>
            </div>
        </div>
    )
}

export default AgeVerificationModal